const userData = [
    {
        "userId": 1,
        "name": "Cobby Kalinsky",
        "user": "ckalinsky0",
        "password": "test123",
        "email": "ckalinsky0@tiny.cc",
        "rating": 3.1,
        "registrationDate": "29.04.2020",
        "profileImg": "https://robohash.org/pariaturvoluptastotam.png?size=200x200&set=set1"
      }, {
        "userId": 2,
        "name": "Norry Reef",
        "user": "nreef1",
        "password": "test123",
        "email": "nreef1@wix.com",
        "rating": 4.0,
        "registrationDate": "01.03.2020",
        "profileImg": "https://robohash.org/quisetrerum.png?size=200x200&set=set1"
      }, {
        "userId": 3,
        "name": "Cicely Sore",
        "user": "csore2",
        "password": "test123",
        "email": "csore2@flickr.com",
        "rating": 3.1,
        "registrationDate": "27.12.2019",
        "profileImg": "https://robohash.org/rerumdoloremasperiores.png?size=200x200&set=set1"
      }
]

export default userData